import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-setting" }
const _hoisted_2 = { class: "margin-bottom-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "应用选择：", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card, {
      shadow: "hover",
      borderDisabled: "",
      bottom: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            modelValue: _ctx.currentApp.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentApp.code) = $event)),
            placeholder: "请选择",
            onChange: _ctx.handleChangeAppType
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APPS, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.code,
                  label: item.name,
                  value: item.code
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        (_ctx.currentApp.code)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.updateComponent), {
              type: _ctx.currentApp.code,
              app: _ctx.currentApp,
              key: _ctx.currentApp.code
            }, null, 8, ["type", "app"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}